import { Injectable } from '@angular/core';
import { Capacitor } from '@capacitor/core';

export type AppPlatform = 'web' | 'ios' | 'android';

export function isNativeShell(): boolean {
  return Capacitor.isNativePlatform();
}

@Injectable({ providedIn: 'root' })
export class PlatformService {
  readonly isNative = Capacitor.isNativePlatform();
  readonly platform = Capacitor.getPlatform() as AppPlatform;
}
